export const faqs = [
  {
    question: "What does the Northstarz.Ai AI recruiter do for me?",
    answer: `a.	Northstarz.Ai takes care of all the initial heavy lifting that human recruiters must do. It will help you with the following tasks during your recruitment process:
        i.	Create Job Descriptions using Generative AI instantly.
        ii.	Generate a JOB URL which you can easily post on any job openings across various job platforms like LinkedIn, Indeed, monster etcetera.
        iii.	It will collect and assess the resumes of all applicants and display them in a single place on your system, Resumes are evaluated with an accuracy of over 80%
        iv.	It will send out interview invitations to all applicants who apply – conduct the interviews and rate the applicants on various soft and hard skills as desired – all without human intervention. 
        v.	It will calculate an aggregated score for each applicant which is a combination of the applicant's resume, interview, and voice confidence scores. You can allocate weights to these parameters while setting up an interview.
        You can now easily reach out to the top applicants by their rank, on your system and focus on just the top talent instead of sifting through hundreds of applicant details and interviews manually.
        `,
    open: false,
  },
  {
    question: "What kind of user roles can you have on the platform?",
    answer: `a.	The system offers three roles as follows:
        i.	Administrator – One who has full access to the portal including the right to create or delete other users, view all job data posted by all other recruiters and edit rights across the system.
        ii.	Editor – This role is for an individual recruiter and gives him or her the right to create new jobs under his responsibilities, view the status of the jobs he has posted and edit or delete rights limited to his or her jobs only.
        iii.	Viewer – The viewer role can be allocated to any hiring manager to give the person a view of the status of job requisitions raised by him/her only.
        `,
    open: false,
  },
  {
    question: "How do I create a new job?",
    answer: `You can add a job under the Jobs tab on the left-hand menu on your system. The system will take you step by step through the process and you will be able to create a new job in just a few minutes and create the URL which you can publish across job portals.`,
    open: false,
  },
  {
    question:
      "Can we use Job boards to source candidates through Northstarz.Ai?",
    answer: `Yes, once you have created a new job, you can easily publish the URL for the job across any job board. The system will automatically collect applicant resumes and start the interview process for the candidate.`,
    open: false,
  },
  {
    question: "How does the pricing work?",
    answer: `We offer various pricing packs for our consumers. Consumers are charged on two pricing parameters – a. The number of users who are accessing the system and b. the number of interviews assessed by the system. You are charged only if the candidate completes the entire interview process.`,
    open: false,
  },
  {
    question: "Can you add candidates manually?",
    answer: `Yes, you can add candidates manually using the Add Candidate functionality under the JOB posting. You can access the applicant details by clicking on the JOB posting to view all applicants for the job from that section as well.`,
    open: false,
  },
  {
    question: "What parameters do you rate candidates on?",
    answer: `a.	We rate candidates on 4 separate parameters. You can assign weights to these parameters as per the role requirements. The following 4 parameters are offered:
        i.	Resume Score – Scoring done by AI based on the resume match with the provided job description.
        ii.	Soft Skills Score – Scoring is done by Machine Learning algorithms trained on hundreds of hours of real human inputs.
        iii.	Technical Skills Score – Scoring is done by AI by mapping the answers given by the applicants in the interview to the answers provided by the recruiter or generated by AI while setting up the Job.
        iv.	Voice Confidence Score – AI runs voice confidence analysis based on a biometric voice scan. 
        `,
    open: false,
  },
  {
    question: "Can I add questions myself?",
    answer: `The recruiter can add technical questions and provide answers for the questions against which the candidates' answers will be scored. The recruiter can also ask our Generative AI to create questions for them for any technical skill evaluation. However, questions for Soft Skills cannot be added manually.`,
    open: false,
  },
  {
    question: "How much time does it take for the interview?",
    answer: `Usually, we suggest that interviews should not last for more than 20 minutes considering it may lead to monotony and possible disruption in the process due to internet connectivity on the candidate side.`,
    open: false,
  },
  {
    question: "Do we also provide candidates?",
    answer: `No, we do not provide candidates now. We allow you to port the job link across various job boards that you use and help you in the candidate evaluation process only.`,
    open: false,
  },
  {
    question: "How to create a new account?",
    answer: `You can create a new account by writing to us at support@northstarz.ai`,
    open: false,
  },
  {
    question: "What do I do if I need any technical support?",
    answer: `You can reach us at support@northstarz.ai or reach out personally to your dedicated account manager.`,
    open: false,
  },
  {
    question:
      "Do I need to send out interview invites and set up time with candidates?",
    answer: `No, you do not need to send out invitations or set up time with the candidates. Your AI recruiter will do all these tasks for you. The system will even remind candidates to take interviews. Our AI recruiter is available 24/7 which means your candidates can take the interview anytime during the stipulated period without any human requirements of assistance.`,
    open: false,
  },
  {
    question: "Can we download the Video Interview views?",
    answer: `No, you cannot download the interviews as this is not permissible legally.`,
    open: false,
  },
  {
    question:
      "How do we reach out to candidates after they have been ranked on your portal?",
    answer: `You can easily reach out to candidates who have been shortlisted by sending them emails on their email IDs from the system informing them about the next steps. You can also choose to send rejection emails to candidates who do not make the shortlist.`,
    open: false,
  },
  {
    question: "How long do Interview assessments take?",
    answer: `Assessments are conducted as soon as the candidate submits the interview he or she has taken, and the score gets displayed on our portal for your review. `,
    open: false,
  },
  {
    question: "How accurate are your assessment?",
    answer:
      "Our combined accuracy for resume scoring, soft skill scoring, technical skill scoring and voice analysis scoring is currently over 80% and is improving constantly as more data is getting fed to the system.",
    open: false,
  },
];
